import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Critere } from 'src/app/utils/interfaces/new/Critere';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { SnackbarService } from '../snackbar/snackbar.service';
import { ResolveCritereInput, ResolveCritereOutput } from 'src/app/utils/interfaces/new/ResolveCritere.interface';

@Injectable({
  providedIn: 'root'
})
export class CritereService {

  private isMock = environment.mock;
  private _wait = (ms) => new Promise(res => setTimeout(res, ms));
  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };
  private uri = environment.basePath + "/personnalisation/criteres";

  constructor(
    private http: HttpClient,
    private _filtresService: FiltresService,
    private _snack: SnackbarService
  ) { }

  public async create(critere: Critere): Promise<string> {
    try {
      critere.id = critere.id || undefined;
      critere.uuid = critere.uuid || undefined;
      critere.format = critere.format || undefined;
      critere.unite = critere.unite || undefined;
      critere.min = critere.min || undefined;
      critere.max = critere.max || undefined;
      critere.alertMin = critere.alertMin || undefined;
      critere.alertMax = critere.alertMax || undefined;
      critere.cotation = critere.cotation || undefined;
      critere.description = critere.description || undefined;
      critere.isUploaded = critere.isUploaded || undefined;
      critere.isDownloaded = critere.isDownloaded || undefined;
      critere.disabled = critere.disabled || undefined;

      const res = await this.http.post(this.uri, critere, this.httpOptions).toPromise();
      const id = res.body as string;
      return id;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async find(filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortBy: 'name'
  }): Promise<Paginated<Critere>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(filtre);
      const res = await this.http.get(this.uri, this.httpOptions).toPromise();
      const criteres = res.body as Critere[];
      const paginated: Paginated<Critere> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: criteres
      };
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async update(critere: Critere) {
    try {
      const res = await this.http.put(this.uri + "/" + critere.id, critere, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findOne(critereId: string): Promise<Critere> {
    try {
      const res = await this.http.get(this.uri + "/" + critereId, this.httpOptions).toPromise();
      const critere = res.body as Critere;
      return critere;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findOneByName(critereName: string): Promise<Critere> {
    try {
      const res = await this.http.get(this.uri + "/name/" + critereName, this.httpOptions).toPromise();
      const critere = res.body as Critere;
      return critere;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async resolveCriteres(data: ResolveCritereInput[]): Promise<ResolveCritereOutput[]> {
    try {
      const res = await this.http.post<ResolveCritereOutput[]>(this.uri + "/resolve", data, this.httpOptions).toPromise();
      return res.body || [];
    } catch (error) {
        this._snack.openSnackBar(error?.error?.message || 'Erreur lors de la résolution des critères');
        throw error;
    }
  }

}
